import { getProduct, getCommentsProduct, createCommentProduct } from "../../services/Api";
import { getImageProduct } from "../../shared/ultils";
import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import moment from "moment";
import { useDispatch } from "react-redux";
import { addToCart } from "../../redux-setup/reducers/cart";

const ProductDetails = () => {
    const [product, setProduct] = useState({});//để null thì product.is_stock ko đc để product?. vì sẽ chớp chớp vì đợi kết quả trả về true/false
    const [comments, setComments] = useState([]);//array
    const [inputComment, setInputComment] = useState(null);//object
    const { id } = useParams();

    //Redux Toolkit
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const clickAddToCart =(type)=>{
        dispatch(addToCart({
            _id: product._id,
            name: product.name,
            thumbnail: product.thumbnail,
            price: product.price,
            qty: 1,
        }));
        if(type==="buy-now"){
            return navigate("/Cart");
        }
    }
    //get Comments
    const getComments = (id) => {
        getCommentsProduct(id)
            .then(({ data }) => {
                // console.log('comment nhe:');
                
                // console.log(data);
                setComments(data.data.docs)
            })
            .catch((error) => console.log(error));
    };
    //get Input Comment
    const onChangeInput = (e) => {
        const { name, value } = e.target;
        setInputComment({ ...inputComment, [name]: value });
    }
    const onSubmitComment = (e) => {
        e.preventDefault();
        createCommentProduct(id, inputComment).then(({ data }) => {
            if (data.status === "create comment successfully") {
                setInputComment(null)
            }
            getComments(id);
        })
    }
    //---------------------------
    useEffect(() => {
        getProduct(id).then(({ data }) => {
            setProduct(data.data);
        });
        getComments(id);
    }, [])//ko co [] se lien tuc chay gay loi Axios Error
    return (
        <>
            <div>
                {/*	List Product	*/}
                <div id="product">
                    <div id="product-head" className="row">
                        <div id="product-img" className="col-lg-6 col-md-6 col-sm-12">
                            <img src={product?.thumbnail && getImageProduct(product?.thumbnail)} />
                        </div>
                        <div id="product-details" className="col-lg-6 col-md-6 col-sm-12">
                            <h1>{product?.name}</h1>
                            <ul>
                                <li><span>Bảo hành:</span> {product.warranty}</li>
                                <li><span>Đi kèm:</span> {product.accessories}</li>
                                <li><span>Tình trạng:</span> {product.status}</li>
                                <li><span>Khuyến Mại:</span> {product.promotion}</li>
                                <li id="price">Giá Bán (chưa bao gồm VAT)</li>
                                <li id="price-number">{Number(product.price).toLocaleString('vi-VN')}đ</li>
                                <li id="status" className={product.is_stock === true ? "text text-success" : "text text-danger"}>{product.is_stock === true ? "Còn hàng" : "Hết hàng"}</li>
                                {/* ko được để dấu ? ở product.is_stock */}
                            </ul>
                            {product.is_stock && (
                                <div id="add-cart">
                                    <button onClick={()=>clickAddToCart("buy-now")} className="btn btn-warning mr-2">
                                        Mua ngay
                                    </button>

                                    <button onClick={clickAddToCart} className="btn btn-info">
                                        Thêm vào giỏ hàng
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                    <div id="product-body" className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <h3>Đánh giá về {product.name}</h3>
                            {product.description}
                        </div>
                    </div>
                    {/*	Comment	*/}
                    <div id="comment" className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <h3>Bình luận sản phẩm</h3>
                            <form method="post">
                                <div className="form-group">
                                    <label>Tên:</label>
                                    <input name="full_name" required type="text" className="form-control"
                                        onChange={onChangeInput}
                                        value={inputComment?.full_name || ""} />
                                </div>
                                <div className="form-group">
                                    <label>Email:</label>
                                    <input name="email" required type="email" className="form-control" id="pwd"
                                        onChange={onChangeInput}
                                        value={inputComment?.email || ""} />
                                </div>
                                <div className="form-group">
                                    <label>Nội dung:</label>
                                    <textarea name="body" required rows={8} className="form-control" defaultValue={""}
                                        onChange={onChangeInput}
                                        value={inputComment?.body || ""} />
                                </div>
                                <button onClick={onSubmitComment}
                                    type="button" name="sbm" className="btn btn-primary">Gửi</button>
                            </form>
                        </div>
                    </div>
                    {/*	End Comment	*/}
                    {/*	Comments List	*/}
                    {/*	co khoang trang neu ko co data comments	*/}
                    {(!comments===null) && (
                    <div id="comments-list" className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            {
                                comments?.map((comment, index) => {
                                    const m = moment(comment.createdAt)
                                    return (
                                        <div key={index} className="comment-item">
                                            <ul>
                                                <li><b>{comment.full_name}</b></li>
                                                <li>{m.fromNow()}</li>
                                                <li>
                                                    <p>{comment.body}</p>
                                                </li>
                                            </ul>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                     )}
                    {/*	End Comments List	*/}
                </div>
                {/*	End Product	*/}
                <div id="pagination">
                    <ul className="pagination">
                        <li className="page-item"><a className="page-link" href="#">Trang trước</a></li>
                        <li className="page-item active"><a className="page-link" href="#">1</a></li>
                        <li className="page-item"><a className="page-link" href="#">2</a></li>
                        <li className="page-item"><a className="page-link" href="#">3</a></li>
                        <li className="page-item"><a className="page-link" href="#">Trang sau</a></li>
                    </ul>
                </div>
            </div>
        </>
    )
}
export default ProductDetails;